import axiosV1 from "@/plugins/axios/configV1";

export default {
    getNewsletters(params = {}) {
        return axiosV1.get("notifs/email-newsletters", { params });
    },
    getDeletedNewsletters(params = {}) {
        return axiosV1.get("notifs/email-newsletters/deleted", { params });
    },
    getNewsletter(id) {
        return axiosV1.get(`notifs/email-newsletters/${id}`);
    },
    createNewsletter(payload = {}) {
        return axiosV1.post("notifs/email-newsletters", payload);
    },
    updateNewsletter(id, payload = {}) {
        return axiosV1.put(`notifs/email-newsletters/${id}`, payload);
    },
    cancelNewsletter(id) {
        return axiosV1.post(`notifs/email-newsletters/${id}/cancel`);
    },
    duplicateNewsletter(id) {
        return axiosV1.post(`notifs/email-newsletters/${id}/duplicate`);
    },
    deleteNewsletter(id) {
        return axiosV1.post(`notifs/email-newsletters/${id}/delete`);
    },
    restoreNewsletter(id) {
        return axiosV1.post(`notifs/email-newsletters/${id}/restore`);
    },
    forceDeleteNewsletter(id) {
        return axiosV1.post(`notifs/email-newsletters/${id}/forceDelete`);
    },
    getNewsletterAnalytics(id) {
        return axiosV1.get(`notifs/email-newsletters/${id}/analytics`);
    },
    previewNewsletterTarget(payload = {}) {
        return axiosV1.post("notifs/email-newsletters/preview-target", payload);
    },
    uploadNewsletterImage(formData) {
        return axiosV1.post("notifs/email-newsletters/upload-image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    deleteNewsletterImage(path) {
        return axiosV1.post("notifs/email-newsletters/delete-image", { path });
    },
    getNewsletterProductOptions(params = {}) {
        return axiosV1.get("notifs/email-newsletters/options/products", { params });
    },
    getNewsletterEventOptions(params = {}) {
        return axiosV1.get("notifs/email-newsletters/options/events", { params });
    },
    getNewsletterUserOptions(params = {}) {
        return axiosV1.get("notifs/email-newsletters/options/users", { params });
    },
    getNewsletterProductOwnershipOptions() {
        return axiosV1.get("notifs/email-newsletters/options/productsOwnership");
    },
};
